export const CONNECT_PROMOTION_CATEGORY_ID: string = '19998'; // TODO: rename to retail after changes in cms.
export type FEATURE_TOGGLE_KEYS = 'EnhancedMultiples' | 'PromoSignposting' | 'FootballCoupons';
export const ONE_TWO_FREE_CONSTS = {
    OTF_FEATURE_TAG: '1-2-Free',
};
export const global_stakes: string = 'global_stakes';
